import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import { config } from '../../../../../../../config/index';
import LayoutContext from '../../../../../../../store/Layout/contexts';
import { GET, newFetch } from '../../../../../../../helpers/fetch';
import ToastUtil from '../../../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../../../components/SweetAlert';
import {
  Form,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  Row,
  InputGroup,
} from 'react-bootstrap';
const { API_URL } = config;

const AddClientUser = ({ history, clientId, setActiveUserTabPage, setActiveTab }) => {
  const [name, setName] = useState('');
  const [position, setPosition] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const nameHandler = (e) => setName(e.target.value);
  const positionHandler = (e) => setPosition(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const passwordHandler = (e) => setPassword(e.target.value);

  const [validated, setValidated] = useState(false);

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setName('');
      setPosition('');
      setEmail('');
      setPassword('');
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitUserHandler(event);
    }

    setValidated(true);
  };

  const existInAdmin = async () => {
    let url = `${API_URL}/client/users/exist-admin`;
    let token = localStorage.getItem('token');
    try {
      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({ email }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
      let responseData = await response.json();
      if (responseData.success) {
        return responseData.data
      }
    } catch (error) {
      ToastUtil.error(error);
    }
  };

  const submitUserHandler = async (event) => {
    event.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to create this User?'
      )
    ) {

      const isExist = await existInAdmin();
      let switch_to_client = false;

      if (isExist) {
        const result = await AlertService.confirm(
          '',
          'Sorry, the email address already exists in admin management. Do you want to switch this user to a client? Please note that the Name, Designation, and Password will be updated.',
          'Yes',
          'No'
        );
        if (result) {
          switch_to_client = true;
        } else {
          return false;
        }
      }

      const data = {
        name: name,
        position,
        email,
        password,
        client_id: clientId,
        switch_to_client,
        exist_in_admin: isExist
      };

      let url = `${API_URL}/client/users/create`;
      let token = localStorage.getItem('token');

      try {
        let response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify(data),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let responseData = await response.json();

        if (responseData.success) {
          // history.push(`/clients/client/${clientId}`);
          setActiveTab('users');
          setActiveUserTabPage('list');
          ToastUtil.success(responseData.message);
        } else {
          ToastUtil.error(responseData.message);
        }

      } catch (error) {
        ToastUtil.error(error);
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/clients/client/${clientId}`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
                onClick={(e) => {
                  e.preventDefault(); 
                  setActiveUserTabPage('list');
                }}
              >
                <div style={{ color: '#0d6efd' }}>
                  <i className="fas fa-chevron-left pe-2"></i> Back to User
                  Management
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add User</h5>
              </div>
            </div>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div
                style={{
                  marginTop: '2rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          <strong>Name*</strong>
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="name"
                          value={name}
                          placeholder="Name"
                          onChange={(e) => nameHandler(e)}
                          maxLength={60}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter name.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          <strong>Position*</strong>
                        </Form.Label>
                        <Form.Control
                          required
                          name="position"
                          value={position}
                          type="text"
                          placeholder="Position"
                          onChange={(e) => positionHandler(e)}
                          maxLength={60}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter position.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          <strong>Email*</strong>
                        </Form.Label>
                        <Form.Control
                          required
                          value={email}
                          type="email"
                          placeholder="Email"
                          onChange={(e) => emailHandler(e)}
                          maxLength={100}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter valid email.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          <strong>Password*</strong>
                        </Form.Label>
                        <Form.Control
                          required
                          value={password}
                          type="password"
                          placeholder="Password"
                          onChange={(e) => passwordHandler(e)}
                          maxLength={50}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter password.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: '2rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '2rem',
                }}
              >
                <div
                // style={{
                //   position: 'fixed',
                //   bottom: 0,
                //   width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                //   height: '4.5rem',
                //   paddingRight: '3rem',
                // }}
                className="d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '7rem' }}
                  onClick={discardHandler}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '7rem' }}
                >
                  Save changes
                </button>
              </div>
              </div>

              
            </Form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddClientUser);
